import { formatDate } from "@angular/common";

export class Utils {
  static clearPhone(phone: string): string { // 8 (950) 012-31-23 => 89500123123
    return phone.replace(/[^0-9]/g,"");
  }

  static formatDate(date: Date): string {
    return formatDate(date, 'dd.MM.yyyy', 'ru');
  }
}
